export default "__VITE_ASSET__81b96923__"